import { createGlobalStyle } from 'styled-components/macro';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`;

interface Theme {
  colors: {
    primary: string;
    primaryBackground: string;
  };
}

export const theme: Theme = {
  colors: {
    primary: '#6E85FC',
    primaryBackground: '#EDF0FF',
  },
};
